export const MY_ORDERS_LOAD = 'MY_ORDERS_LOAD';
export const MY_ORDERS_LOADED = 'MY_ORDERS_LOADED';
export const VIEW_ORDER_LOAD = 'VIEW_ORDER_LOAD';
export const VIEW_ORDER_LOADED = 'VIEW_ORDER_LOADED';
